// src/pages/About.tsx
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Check, Target, TrendingUp, BarChart3, ArrowRight } from "lucide-react";
import CallToActionFooter from "@/components/Footer";
import Navbar from "@/components/Navbar";
import mainlogo from "@/assets/mylistiq-logo-new.png";
// import Chatbot from "@/components/Chatbot";
// import CallingBot from "@/components/Callingbot";
import BotLauncher from "@/components/BotLauncher";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Navbar */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-gradient-to-b  from-blue-100/90 to-blue-50/90">
        {/* Gradient bottom line */}
        <div className="h-[1.5px] w-full bg-gradient-to-r from-transparent to-transparent" />

        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <Link
                to="/"
                onClick={(e) => {
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
                className="flex items-center gap-2"
              >
                <img
                  src={mainlogo}
                  alt="MyListIQ"
                  className="h-12 w-auto drop-shadow-sm"
                />
              </Link>
            </div>

            {/* Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
              >
                Features
              </Link>

              <Link
                to="/"
                className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
              >
                Pricing
              </Link>

              <Link
                to="/about"
                className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
              >
                About
              </Link>

              {/* CTA Button */}
              <Button
                asChild
                size="sm"
                className="
            text-base font-semibold
            bg-gradient-to-r from-blue-600 to-indigo-600
            hover:from-blue-700 hover:to-indigo-700
            shadow-md hover:shadow-xl
            transition-all
          "
              >
                <Link
                  to={
                    localStorage.getItem("access_token")
                      ? "/dashboard"
                      : "/signup"
                  }
                >
                  {localStorage.getItem("access_token")
                    ? "Dashboard"
                    : "Sign Up"}
                </Link>
              </Button>
{/* 
              <Button
                asChild
                size="sm"
                className="
 text-base font-semibold
                bg-red-600
                hover:bg-red-700
                text-white
                shadow-md hover:shadow-xl
                transition-all duration-300
  "
              >
                <Link
                  to="/beta-agreement"
                  className="flex items-center justify-center px-4 py-2"
                >
                  Beta Agreement
                </Link>
              </Button> */}

              {/* <Button
                asChild
                size="sm"
                className="
 text-base font-semibold
                bg-red-600
                hover:bg-red-700
                text-white
                shadow-md hover:shadow-xl
                transition-all duration-300
"
              >
                <Link
                  to="/beta-checklist"
                  className="text-white-600 hover:text-white-600 font-medium transition-colors"
                >
                  Beta Checklist
                </Link>
              </Button> */}
            </div>
          </div>
        </div>
      </header>

      {/* Hero Header - No background color now (plain white) */}
      <section className="py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 text-center space-y-8">
          <h1 className="text-4xl lg:text-6xl font-bold tracking-tight">
            About <span className="text-blue-600">MyList<span className="text-red-600">IQ</span></span>
          </h1>
          <p className="text-xl lg:text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            At MyListIQ, we're redefining how real estate professionals or
            affiliates market their services — making it{" "}
            <span className="font-bold text-blue-600">
              Easy. Affordable. <span className="text-red-600">Smarter.</span>
            </span>
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 space-y-16">
          {/* Our Story */}
          <Card className="bg-white shadow-xl border-0 rounded-2xl overflow-hidden">
            <CardContent className="p-8 lg:p-12">
              <p className="text-lg text-gray-700 leading-relaxed">
                With over a decade in real estate and over two decades in the IT
                industry, we’ve combined deep industry insight with cutting-edge
                technology to create a solution tailored specifically for
                today’s market. Our platform harnesses the power of AI to
                simplify and elevate the listing process, helping you stand out
                in a crowded market.
              </p>
            </CardContent>
          </Card>

          {/* What We Do */}
          <div className="space-y-12">
            <div className="text-center">
              <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                What We <span className="text-blue-600">Do</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                MyListIQ uses advanced AI tools to enhance your real estate
                marketing
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group rounded-2xl overflow-hidden">
                <CardContent className="p-8 text-center">
                  <div className="bg-blue-600 text-white p-4 rounded-xl w-fit mx-auto mb-6 transition-transform group-hover:scale-110">
                    <Target className="h-8 w-8" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Photo Enhancement
                  </h3>
                  <p className="text-gray-600">
                    Enhance photos automatically for stunning, scroll-stopping
                    visuals
                  </p>
                </CardContent>
              </Card>

              <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group rounded-2xl overflow-hidden">
                <CardContent className="p-8 text-center">
                  <div className="bg-blue-600 text-white p-4 rounded-xl w-fit mx-auto mb-6 transition-transform group-hover:scale-110">
                    <Check className="h-8 w-8" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Compelling Descriptions
                  </h3>
                  <p className="text-gray-600">
                    Write compelling descriptions that highlight your property’s
                    best features
                  </p>
                </CardContent>
              </Card>

              <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group rounded-2xl overflow-hidden">
                <CardContent className="p-8 text-center">
                  <div className="bg-blue-600 text-white p-4 rounded-xl w-fit mx-auto mb-6 transition-transform group-hover:scale-110">
                    <TrendingUp className="h-8 w-8" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Catchy Subject Lines
                  </h3>
                  <p className="text-gray-600">
                    Generate catchy subject lines to grab attention fast
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Affordability Section */}
          <Card className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-0 rounded-2xl shadow-2xl">
            <CardContent className="p-12 text-center">
              <h3 className="text-3xl lg:text-4xl font-bold mb-6">
                Affordable & Flexible
              </h3>
              <p className="text-xl opacity-90 max-w-4xl mx-auto leading-relaxed">
                We make it affordable with flexible subscription plans,
                including the ability to rollover your plan for 1 or 2 months —
                because we understand that real estate has its ups and downs.
              </p>
            </CardContent>
          </Card>

          {/* Smart Features */}
          <div className="space-y-12">
            <div className="text-center">
              <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                Smarter <span className="text-blue-600">Marketing</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                We offer powerful insights and tracking to optimize your success
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 rounded-2xl overflow-hidden">
                <CardContent className="p-8">
                  <div className="bg-blue-600 text-white p-4 rounded-xl w-fit mb-6">
                    <TrendingUp className="h-8 w-8" />
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">
                    Market Trend Insights
                  </h4>
                  <p className="text-gray-600">
                    Stay ahead with real-time market intelligence
                  </p>
                </CardContent>
              </Card>

              <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 rounded-2xl overflow-hidden">
                <CardContent className="p-8">
                  <div className="bg-blue-600 text-white p-4 rounded-xl w-fit mb-6">
                    <BarChart3 className="h-8 w-8" />
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">
                    Marketing Performance Analytics
                  </h4>
                  <p className="text-gray-600">
                    Track and optimize your marketing launches
                  </p>
                </CardContent>
              </Card>

              <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 rounded-2xl overflow-hidden">
                <CardContent className="p-8">
                  <div className="bg-blue-600 text-white p-4 rounded-xl w-fit mb-6">
                    <Check className="h-8 w-8" />
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">
                    Tracking Tools
                  </h4>
                  <p className="text-gray-600">
                    Help you understand what’s working and where to focus
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Mission Statement */}
          <Card className="bg-white shadow-2xl border-0 rounded-2xl overflow-hidden">
            <CardContent className="p-12 text-center">
              <h2 className="text-4xl lg:text-5xl font-bold mb-8">
                Our <span className="text-blue-600">Mission</span>
              </h2>
              <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed mb-8">
                At MyListIQ, our mission is to empower agents and professionals
                with tools that do more — so you can list smarter, market
                better, and succeed faster.
              </p>
              <p className="text-2xl font-bold text-blue-600">
                Let MyListIQ be your AI-powered edge in real estate marketing.
              </p>
            </CardContent>
          </Card>

          {/* CTA */}
          <div className="text-center pt-12">
            <Button
              asChild
              size="lg"
              className="
                text-xl font-bold
                bg-gradient-to-r from-blue-600 to-indigo-600
                hover:from-blue-700 hover:to-indigo-700
                text-white
                shadow-lg hover:shadow-2xl
                transition-all duration-300
                px-12 py-8
              "
            >
              <Link to="/signup">
                Get Started Today <ArrowRight className="ml-3 h-6 w-6" />
              </Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <CallToActionFooter />
      {/* <CallingBot/>
      <Chatbot /> */}
      <BotLauncher />
    </div>
  );
};

export default About;
